<template>
    <div class="component-filters">
        <el-dialog
                title="Выбрать фильтр"
                :visible.sync="applyVisible"
                :loading="loadingApply"
                width="435px"
        >
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        Apply
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="m-t-20">
                    <el-col :span="24" class="align-right">
                        <el-button type="primary" icon="el-icon-check" @click="apply">Применить</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <el-dialog
                title="Настроить фильтр вручную"
                :visible.sync="editVisible"
                :loading="loadingEdit"
                width="435px"
        >
            <div>
                <el-row :gutter="20">
                    <el-col :span="24">
                        Edit
                    </el-col>
                </el-row>
                <el-row :gutter="20" class="m-t-20">
                    <el-col :span="24" class="align-right">
                        <el-button type="primary" icon="el-icon-check" @click="edit">Применить</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-dialog>

        <el-button @click="applyDialog" icon="icon-check"></el-button>
        <el-button @click="editDialog" icon="icon-edit"></el-button>
        <el-button @click="reset" icon="icon-trash"></el-button>

        <!--<div class="filter">-->
            <!--<div v-for="(item, index) in filter.conditions" :key="index">-->
                <!--{{item}}-->
            <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    export default {
        data () {
            return {
                filter: {
                    name: 'События парковки',
                    conditions: [
                        {
                            name: 'SumInNoteAccepter',
                            text: 'Сумма в купюроприемнике',
                            check: '<',
                            value: '500000',
                            ValueText: ""
                        }
                    ]
                },
                applyVisible: false,
                editVisible: false,
                loadingApply: false,
                loadingEdit: false,
            }
        },
        methods: {
            applyDialog () {
                this.applyVisible = true
            },
            apply () {
                this.applyVisible = false
                this.$emit('apply')
            },
            editDialog () {
                this.editVisible = true
            },
            edit () {
                this.editVisible = false
                this.$emit('apply')
            },
            reset () {
                this.$confirm('Сбросить фильтр?', 'Предупреждение', {
                    confirmButtonText: 'Сбросить',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    console.log('Reset')
                    this.$emit('reset')
                })
            }
        }
    }
</script>

<style scoped>

</style>
